import { ColumnHeader, Loading, SearchBox, Table } from '@aon/aon-tws-common-ui';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { IColumn } from '../../../models';
import { ISurveyTemplate } from '../../../models/ISurveyTemplate';
import { IApplicationState } from '../../../store';
import { getSurveyTemplates } from '../../../store/SurveyTemplateSlice';
import { ColumnHelper } from '../../../utilities';
import { LoadingWrapper } from '../../common/LoadingWrapper';
import { TemplateRow } from './TemplateRow';

export const SearchBoxWrapper = styled.div`
	display: block;
	width: 30%;
	margin-left: auto;
	margin-right: 0;
`;

export const columns: IColumn[] = [
	{
		displayText: 'Template Name',
		name: 'templateName',
		checked: true,
		displayOrder: 1,
		disabled: false,
		sortAscByDefault: true,
		isSortable: false,
	},
];

export interface ITemplateTableProps {
	selectedSurveyTemplateId: number | null;
	onTemplateSelect: (id: number) => void;
}

export const TemplateTable = (props: ITemplateTableProps) => {
	const { selectedSurveyTemplateId, onTemplateSelect } = props;
	const [searchText, setSearchText] = useState('');
	const dispatch = useDispatch();
	const { templates, isLoading } = useSelector((state: IApplicationState) => state.surveyTemplates);

	useEffect(() => {
		dispatch(getSurveyTemplates());
	}, [dispatch]);

	const filteredTemplates = templates.filter((t: ISurveyTemplate) => t.name.toLowerCase().includes(searchText.toLowerCase()));

	return (
		<>
			<SearchBoxWrapper>
				<SearchBox
					callbackFunc={setSearchText}
					resultsCount={filteredTemplates.length}
					initialSearchText={searchText}
					inputSize={'sm'}
					data-testid={'search-box'}
				/>
			</SearchBoxWrapper>
			{isLoading ? (
				<LoadingWrapper>
					<Loading height={'70px'} width={'70px'} />
				</LoadingWrapper>
			) : (
				<Table responsive={true}>
					<ColumnHeader columns={ColumnHelper.GetColumnHeaders(columns)} headerCheckboxSortable={false} />
					<tbody>
						{filteredTemplates?.map((template) => (
							<TemplateRow
								key={template.name}
								template={template}
								columns={columns}
								searchText={searchText}
								isSelected={selectedSurveyTemplateId === template.surveyId}
								onSelect={() => onTemplateSelect(template.surveyId)}
							/>
						))}
					</tbody>
				</Table>
			)}
		</>
	);
};
